//  Version : 0.0.1
//  Author : VISHNU
// LastEdit : KARTHEESWARAN
// LASTADD : Removed excel Redux
// MODFIED DATE:12-11-2025

import ArrearFollowupActionTypes from './arrear-followup-report.type';

/*************** GET ARREAR FOLLOWUP LIST START ************/
export const getArrearFollowupDetailsStart = (getData: any) => ({
	type: ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_START,
	payload: getData,
});

export const getArrearFollowupDetailsSuccess = (successData: any) => ({
	type: ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_SUCCESS,
	payload: successData,
});

export const getArrearFollowupDetailsFailure = (failureData: any) => ({
	type: ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_FAILURE,
	payload: failureData,
});

export const getArrearFollowupDetailsResponseResetStart = () => ({
	type: ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_RESPONSE_RESET,
});

export const getArrearFollowupDetailsResponseChanged = () => ({
	type: ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_RESPONSE_CHANGED,
});

/*************** GET ARREAR FOLLOWUP LIST END ************/
